import * as React from 'react';

import * as s from './PostForm.css';

export interface IBlogPostFormLayout {
  heading: React.ReactNode;
  titleField: React.ReactNode;
  featuredImageField: React.ReactNode;
}

/**
 * Шаблон формы добавления/редактирования поста блога
 */
export const BlogPostFormLayout = ({ heading, titleField, featuredImageField }: IBlogPostFormLayout) => {
  return (
    <div className={s['wrapper']}>
      <div className={s['heading']}>{heading}</div>

      <form className={s['form']}>
        <div className={s['field']}>{titleField}</div>
        <div className={s['field']}>{featuredImageField}</div>
      </form>
    </div>
  );
};
